import { config as authConfig } from 'utils/config';

export const BASE_URL = authConfig.reactAppBackendBaseUrl;
export const LOGIN_INFO_PATH = `${BASE_URL}/services/auth/login-info`;
export const MAGIC_LINK_PATH = `${BASE_URL}/services/auth/magic-link`;
